"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const BoolCellRenderer_1 = __importDefault(require("../BoolCellRenderer"));
const gridUtils_1 = require("../gridUtils");
const GridColumnTypes = {
    'derivedColumn': { editable: false, cellClass: 'derived' },
    'hiddenColumn': {
        suppressColumnsToolPanel: true,
        hide: true,
        editable: false,
    },
    'booleanColumn': {
        cellRenderer: BoolCellRenderer_1.default,
        width: 75,
        valueSetter: (0, gridUtils_1.booleanValueSetter)(),
    },
    // date column with special date comparator that supports d.m.y. format
    'dateColumn': {
        comparator: gridUtils_1.dateComparator,
        filter: 'agDateColumnFilter',
        filterParams: {
            buttons: ['reset'],
            comparator: gridUtils_1.dateFilterComparator,
            browserDatePicker: true,
            minValidYear: 2000,
        },
        suppressMenu: true
    },
    'perm_editConfirmedLabel': {}
};
exports.default = GridColumnTypes;
